export const arr0 = [
  { text: 'Молодец! Ты успешно прошел все задания. Теперь: <br> – посмотри финальный ролик-рефлексию <br> – послушай лекцию о генерации музыки* <br> – участвуй в конкурсе*', buttonTitle: 'Участвовать в конкурсе', buttonTitle2: 'Получить сертификат' },
]
